import React from 'react'
import { ImagePath } from '../../../assets/ImagePath';


const FloatingChatwidgetIcon = ({
    notificationCount = 0,
    chatwidgetNotifications = [],
    handleCloseFloatMessage = () => { },
    handleChatWidgetClick = () => { },
    selectedBotDetails = {}

}) => {
    return (
        <>
            {chatwidgetNotifications?.some(msg => msg.show) && (
                <div className="fixed bottom-[82px] right-[29px] flex justify-content-end flex-col gap-2 z-50 max-w-[383px]">
                    {chatwidgetNotifications.filter(msg => msg.show)
                        .sort((a, b) => a.createdOn - b.createdOn) // Oldest to newest
                        .slice(-3).map((msg, i) =>
                            msg.show ? (
                                <div
                                    key={msg.messageId || i}
                                    className="bg-white rounded-10 px-4 py-3 pe-[2rem] w-full shadow-lg"
                                >
                                    <div className="flex justify-between gap-5">
                                        <h4 className="text-sm font-medium">
                                            {msg.message ?? ""}
                                        </h4>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                            className="size-4 cursor-pointer min-w-[1rem] absolute top-[14px] right-[5px]"
                                            onClick={() => handleCloseFloatMessage(msg)}
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M6 18 18 6M6 6l12 12"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            ) : null
                        )}
                </div>
            )}
             {selectedBotDetails && !selectedBotDetails?.chatButtonHidden && 
            <div
                className="chatwidget-floating-button fixed bottom-3 right-4 z-50 cursor-pointer"
                onClick={handleChatWidgetClick}
            >
                <img
                    src={ImagePath.floatImage}
                    alt="Chat Widget"
                    className="w-[70px] h-[70px]"
                />
               
                {notificationCount > 0 && (
                    <div className="absolute top-[7px] right-[42px] bg-[#ff0000] w-[22px] h-[22px] rounded-full flex items-center justify-center">
                        <div className="text-white text-xs font-semibold">
                            {notificationCount}
                        </div>
                    </div>
                )}
            </div>}
        </>
    )
};

export default FloatingChatwidgetIcon